module.exports = __webpack_public_path__ + "img/ada.a429378d.svg";